import { Toaster } from "@foreday/ui/components/toast";
import type { QueryClient } from "@tanstack/react-query";
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
} from "@tanstack/react-router";
import { toasterArea } from "@/client/lib/toast-area";
import { site } from "@/site";

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  // Fallback for a route that sets no title of its own.
  head: () => ({ meta: [{ title: site.name }] }),
  component: Root,
});

function Root() {
  return (
    <>
      <HeadContent />
      <Outlet />
      <Toaster position="bottom-center" ref={toasterArea} />
    </>
  );
}
